import React, { Component } from "react";
import clsx from "clsx";
import { styled } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { checkPrivileges } from "../../Helpers";
import { matchPath, NavLink } from "react-router-dom";
import { Tooltip, Collapse } from "@mui/material";
import { withStyles } from "@mui/styles";

import "react-toastify/dist/ReactToastify.css";
import "./index.scss";
import Scrollbar from "react-scrollbars-custom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import withRoutes from "../../HOC/HocRoutes";
import { buildNavigation, NAV_SECTIONS } from "../menuConfig";
const drawerWidth = 195;

const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    backgroundColor: "transparent",
    zIndex: theme.zIndex?.drawer + 1,
    boxShadow: "none",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
  },
  menuButton: {},
  hide: {
    display: "none",
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    backgroundColor: "#fff",
    width: drawerWidth,
    marginTop:
      localStorage.getItem("adminToken") || localStorage.getItem("userToken")
        ? 0
        : 47,
    bottom: 0,
    height: "auto",
    transition: "0.3s ease",
  },
  drawerClose: {
    bottom: 0,
    marginTop:
      localStorage.getItem("adminToken") || localStorage.getItem("userToken")
        ? 0
        : 47,
    height: "auto",
    overflowX: "hidden",
    width: 50,
    transition: "0.3s ease",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    ...theme.mixins?.toolbar,
    backgroundColor: "transparent",
  },
  content: {
    flexGrow: 1,
  },
});

const CustomDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {},
}));

class MainSideBar extends Component {
  constructor(props) {
    super(props);
    const sectionOpen = {};
    NAV_SECTIONS.forEach((section) => {
      sectionOpen[`section_${section.id}`] = true;
    });
    this.state = {
      open: true,
      navigation: buildNavigation(props.userInfo, props.translate),
      ...sectionOpen,
    };
  }

  componentDidMount() {
    this.syncDropdownOpenForRoute(this.props.location?.pathname);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      this.syncDropdownOpenForRoute(
        this.props.location?.pathname,
        prevProps.location?.pathname,
      );
    }
  }

  routeMatchesDropdown = (item, pathname) => {
    if (!item || !pathname) return false;
    const parentMatchPath =
      item.title === "payments" ? "/new_payment/*" : item.href;
    if (matchPath({ path: parentMatchPath, end: true }, pathname)) return true;

    const matchNavChild = (href) => {
      if (href === "/workshop-payment") {
        return !!matchPath(
          { path: "/workshop-payment/*", end: true },
          pathname,
        );
      }
      return !!matchPath({ path: href, end: true }, pathname);
    };

    return (
      item.children?.some(
        (child) => child.checked && matchNavChild(child.href),
      ) || false
    );
  };

  isDropdownItem = (item) =>
    item.title === "invoices" ||
    item.title === "Integration" ||
    item.title === "payments" ||
    item.title === "notInContract" ||
    item.title === "fleet" ||
    (item.title === "missedOpportunities" && item.children?.length);

  syncDropdownOpenForRoute = (pathname, prevPathname) => {
    const navigation = this.state.navigation || {};
    const updates = {};

    Object.values(navigation).forEach((item) => {
      if (!item?.checked || !this.isDropdownItem(item)) return;
      const stateKey = `open_${item.title}`;
      // Already open — don't touch state (avoids child list remount/flash)
      if (this.state[stateKey]) return;

      const matches = this.routeMatchesDropdown(item, pathname);
      const matchedBefore = prevPathname
        ? this.routeMatchesDropdown(item, prevPathname)
        : false;
      if (matches && !matchedBefore) {
        updates[stateKey] = true;
      }
    });

    if (Object.keys(updates).length) this.setState(updates);
  };

  toggleSection = (sectionId) => {
    const stateKey = `section_${sectionId}`;
    this.setState({ [stateKey]: !this.state[stateKey] });
  };

  renderInvoicesDropdown(item) {
    const { location, translate, sidebarToggle } = this.props;
    const { icon: ItemIcon, parentIcon: ParentIcon, children } = item;

    const stateKey = `open_${item.title}`;
    const isOpen = !!this.state[stateKey];

    const parentMatchPath =
      item.title === "payments" ? "/new_payment/*" : item.href;
    const isParentActive = !!matchPath(
      { path: parentMatchPath, end: true },
      location.pathname,
    );
    const matchNavChild = (href) => {
      if (href === "/workshop-payment") {
        return !!matchPath(
          { path: "/workshop-payment/*", end: true },
          location.pathname,
        );
      }
      return !!matchPath({ path: href, end: true }, location.pathname);
    };
    const isAnyChildActive =
      children?.some((child) => child.checked && matchNavChild(child.href)) ||
      false;

    const isActive = isParentActive || isAnyChildActive;

    // Flat nested rows so we can highlight only parent → active child path
    const nestedRows = [];
    if (item.title === "invoices" || item.title === "fleet") {
      nestedRows.push({
        key: "parent-link",
        href: item.href,
        label: translate(
          item.title === "fleet" ? "viewFleet" : "viewInvoices",
        ),
        Icon: ParentIcon,
        isRowActive: isParentActive,
      });
    }
    if (item.title === "payments") {
      nestedRows.push({
        key: "parent-link",
        href: item.href,
        label: translate("customerPayments"),
        Icon: ParentIcon,
        isRowActive: isParentActive,
      });
    }
    (children || [])
      .filter((child) => child.checked)
      .forEach((childItem) => {
        nestedRows.push({
          key: childItem.href,
          href: childItem.href,
          label: translate(childItem.title),
          Icon: childItem.icon,
          isRowActive: matchNavChild(childItem.href),
        });
      });

    const activeRowIndex = nestedRows.findIndex((row) => row.isRowActive);

    // Collapsed drawer: icon-only link (same as other nav items)
    if (!sidebarToggle) {
      return (
        <Tooltip key={item.title} title={translate(item.title)}>
          <li>
            <ListItem
              button
              to={item.href}
              component={NavLink}
              className={`listItem ${isActive ? "active" : ""}`}
            >
              <ListItemIcon style={{ Width: 35, color: "inherit" }}>
                {ItemIcon && (
                  <ItemIcon
                    fill="currentColor"
                    width={20}
                    height={20}
                    style={{ marginLeft: -2 }}
                  />
                )}
              </ListItemIcon>
            </ListItem>
          </li>
        </Tooltip>
      );
    }

    return (
      <div className="nav-tree-group">
        <ListItem
          button
          onClick={() => this.setState({ [stateKey]: !this.state[stateKey] })}
          className={`listItem nav-tree-parent ${isActive ? "active" : ""}`}
        >
          <ListItemIcon style={{ minWidth: 20, color: "inherit" }}>
            {ItemIcon && (
              <ItemIcon
                width={20}
                height={20}
                fill="currentColor"
                style={{ marginLeft: -2 }}
              />
            )}
          </ListItemIcon>

          <ListItemText
            primary={translate(item.title)}
            style={{ marginTop: 0, marginBottom: 0, paddingLeft: 18 }}
          />

          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        {isOpen ? (
          <List component="div" disablePadding className="nav-nested-list">
            {nestedRows.map((row, idx) => {
              const RowIcon = row.Icon;
              const isLast = idx === nestedRows.length - 1;
              const onActivePath =
                activeRowIndex >= 0 && idx <= activeRowIndex;
              const isActiveLeaf = row.isRowActive;

              return (
                <ListItem
                  key={row.key || idx}
                  button
                  to={row.href}
                  component={NavLink}
                  className={clsx(
                    "listItem",
                    "listItem--nested",
                    isActiveLeaf && "active",
                    isActiveLeaf && "listItem--nested-active",
                    onActivePath && "listItem--nested-path",
                    isLast && "listItem--nested-last",
                  )}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ListItemIcon style={{ minWidth: 20, color: "inherit" }}>
                    {RowIcon && (
                      <RowIcon
                        width={20}
                        height={20}
                        fill="currentColor"
                        style={{ marginLeft: -2 }}
                      />
                    )}
                  </ListItemIcon>

                  <ListItemText
                    primary={row.label}
                    style={{ marginTop: 0, marginBottom: 0 }}
                  />
                </ListItem>
              );
            })}
          </List>
        ) : null}
      </div>
    );
  }

  renderNavItem(keyName, item) {
    if (this.isDropdownItem(item)) {
      return (
        <React.Fragment key={keyName}>
          {this.renderInvoicesDropdown(item)}
        </React.Fragment>
      );
    }

    const ItemIcon = item.icon;

    return (
      <Tooltip key={keyName} title={this.props.translate(item.title)}>
        <li>
          <ListItem
            button
            to={item.href}
            component={NavLink}
            className="listItem"
          >
            <ListItemIcon style={{ Width: 35, color: "inherit" }}>
              <ItemIcon
                fill="currentColor"
                width={20}
                height={20}
                style={{ marginLeft: -2 }}
              />
              {this.props.sidebarToggle ? (
                <ListItemText
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    paddingLeft: 18,
                  }}
                  primary={this.props.translate(item.title)}
                />
              ) : null}
            </ListItemIcon>
          </ListItem>
        </li>
      </Tooltip>
    );
  }

  render() {
    const { classes, sidebarToggle, translate } = this.props;
    const navigation = this.state.navigation || {};

    return (
      <div className={classes.root + " main-navigation"}>
        {checkPrivileges("accountShowbar") ? (
          <CustomDrawer
            style={{ top: "50px" }}
            variant="permanent"
            PaperProps={{
              className: clsx({
                [classes.drawerOpen]: sidebarToggle,
                [classes.drawerClose]: !sidebarToggle,
              }),
            }}
          >
            <Scrollbar>
              <List>
                {NAV_SECTIONS.map((section) => {
                  const visibleItems = section.keys
                    .map((keyName) => {
                      const item = navigation[keyName];
                      if (!item?.checked) return null;
                      return { keyName, item };
                    })
                    .filter(Boolean);

                  if (!visibleItems.length) return null;

                  const sectionStateKey = `section_${section.id}`;
                  const isSectionOpen = this.state[sectionStateKey] !== false;
                  const navItems = visibleItems.map(({ keyName, item }) =>
                    this.renderNavItem(keyName, item),
                  );

                  // Collapsed drawer: icon-only list, no section chrome / no collapse fight
                  if (!sidebarToggle) {
                    return (
                      <React.Fragment key={section.id}>{navItems}</React.Fragment>
                    );
                  }

                  return (
                    <React.Fragment key={section.id}>
                      <li
                        className="nav-section-label"
                        onClick={() => this.toggleSection(section.id)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.toggleSection(section.id);
                          }
                        }}
                      >
                        <span>{translate(section.titleKey)}</span>
                        {isSectionOpen ? (
                          <ExpandLess fontSize="small" />
                        ) : (
                          <ExpandMore fontSize="small" />
                        )}
                      </li>
                      {isSectionOpen ? navItems : null}
                    </React.Fragment>
                  );
                })}
              </List>
            </Scrollbar>
          </CustomDrawer>
        ) : null}
      </div>
    );
  }
}
export default withStyles(useStyles)(withRoutes(MainSideBar));
